import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/InstitutionGroups'
import { InstitutionGroupDialog } from './dialog'

class InstitutionGroupDialogShell extends React.Component {
  componentDidMount () {
    if (this.props.id > 0) {
      this.props.getById(this.props.id)
    } else {
      this.props.createNew()
    }
  }
  render () {
    const { institutionGroup, fetching, updating, closeDialog, title, componentKey, disabled } = this.props
    return (
      <InstitutionGroupDialog
        key={componentKey}
        disabled={disabled}
        institutionGroup={institutionGroup}
        loading={fetching || updating}
        closeDialog={closeDialog}
        title={title}
        onAction={dto => {
          this.props.addOrUpdate(dto, () => this.props.closeDialog())
        }}
      />
    )
  }
}

function mapStateToProps (state) {
  return {
    ...state.institutionGroups
  }
}

const mapDispatchToProps = {
  getById: actionCreators.getById,
  addOrUpdate: actionCreators.addOrUpdate,
  createNew: actionCreators.createNew
}

export default {
  component: connect(mapStateToProps, mapDispatchToProps)(InstitutionGroupDialogShell),
  modalProps: { size: 'lg' }
}



// WEBPACK FOOTER //
// ./src/dialogs/institutionGroup/index.js